import React from "react";
import { ReactComponent as Print } from "../../../assets/icons/print.svg";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrowDown.svg";

const ViewBrochures = ({ item, index }) => {
  const print = (event) => {
    if (event.target.tagName === "DIV") {
      window.open(event.target.getAttribute("file"));
    } else {
      let event_ = event.target.parentElement;
      if (event_?.tagName === "svg") {
        event_ = event_?.parentElement;
      }
      const doc = event_.getAttribute("file");
      window.open(doc);
    }
  };

  return (
    <div className="child" key={index}>
      <div>
        <img src={item.image} alt="Brochure" />
        <div className="wrapper-buttons">
          <div
            file={item.pdf}
            onMouseDown={(event) => {
              if (event.button === 1 || event.button === 0) {
                print(event);
                event.preventDefault();
              }
            }}
          >
            <span>Print</span>
            <Print />
          </div>
          <a
            onMouseDown={(event) => {
              if (event.button === 1 || event.button === 0) {
                event.preventDefault();
              }
            }}
            className="bg-transparent border-0 hover-class"
            href={item.pdf}
            download
          >
            <span>Download</span>
            <ArrowDown />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ViewBrochures;
